import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";

import { useJsonApi } from "@/modules/api/hooks/useJsonApi";
import { queryKeys } from "@/modules/api/queryKeys";
import { apiErrorValidate } from "@/modules/api/utils/apiErrorValidate";
import { useAuthContext } from "@/modules/auth/hooks/useAuthContext";

import { getDashboardTasksQuery } from "../../api/queries/getDashboardTasksQuery";
import { parseDashboardTasksList } from "../utils/parseDashboardTasksList";

const translationNamespace = "apiMessages/useGetTasksQuery";

const maxAgeDays = 3;

export function useGetDashboardTasksQuery() {
  const jsonApi = useJsonApi();
  const { t } = useTranslation(translationNamespace);

  const { userCompanyId } = useAuthContext();
  return useQuery(
    userCompanyId
      ? {
          queryKey: [queryKeys.dashboard.getDashboardTasksList, userCompanyId],
          queryFn: () =>
            getDashboardTasksQuery(jsonApi, {
              companyId: userCompanyId,
              maxAgeDays,
            }),
          retry: false,
          refetchOnWindowFocus: false,
          select: (response) => {
            if (response) {
              return parseDashboardTasksList(response);
            }
          },
          onError: (error) => {
            apiErrorValidate(error, {
              401: {
                UNAUTHORIZED: t(
                  "You are not allowed to view tasks. Please sign in again"
                ),
              },
              403: {
                ACCESS_FORBIDDEN: t("You don't have an access to view tasks"),
              },
              404: {
                COMPANY_NOT_FOUND: t("Company has not been found"),
              },
            });
          },
        }
      : { enabled: false }
  );
}
